import { TabGroup } from '@headlessui/react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface PageTabGroupProps extends Record<string, unknown> {
  className?: string
}

export const PageTabGroup = ({ className, ...props }: PageTabGroupProps) => {
  return (
    <div className={twMerge(`w-full`, className)}>
      <TabGroup {...props} />
    </div>
  )
}
